import axios from 'axios';

// Use relative URL in development to work with proxy
const API_URL = process.env.NODE_ENV === 'production' 
  ? (process.env.REACT_APP_API_URL || 'https://api.prepstop.com')
  : ''; // Empty string means use proxy in development

const axiosInstance = axios.create({
  baseURL: API_URL,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add token to requests
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('authToken');
    if (token) {
      config.headers = config.headers || {};
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export const campusAmbassadorService = {
  // Get my stats (for currently logged-in campus ambassador)
  getMyStats: async () => {
    const response = await axiosInstance.get('/api/campus-ambassador/my-stats');
    return response.data;
  },
};
